
import { Breadcrumb } from 'react-bootstrap'
import styles from './index.module.scss'

const StyledBreadcrumb = (props) => (
  <Breadcrumb className={styles.breadcrumbs} {...props} />
)

StyledBreadcrumb.Item = (props) => (
  <Breadcrumb.Item className={styles.breadcrumbsItem} {...props} />
)

export default StyledBreadcrumb
